import React from 'react';
import dlaBanner from '../images/dla-banner.jpg';
import './DLAs.css';

const BankIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.5 2.5 7.5V9.5h19V7.5z" />
    <rect x="4.5" y="10.5" width="2.6" height="7" rx="0.4" />
    <rect x="9.1" y="10.5" width="2.6" height="7" rx="0.4" />
    <rect x="13.7" y="10.5" width="2.6" height="7" rx="0.4" />
    <rect x="18.3" y="10.5" width="1.6" height="7" rx="0.4" />
    <rect x="3" y="18.5" width="18" height="2.5" rx="0.5" />
  </svg>
);

const PlatformIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="12.5" rx="1.5" />
    <path d="M12 16.5v3.5M8 20h8" />
  </svg>
);

const OperatorIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <circle cx="12" cy="7.5" r="3.2" />
    <circle cx="5.3" cy="9.3" r="2.4" />
    <circle cx="18.7" cy="9.3" r="2.4" />
    <path d="M6.5 19.5a5.5 5.5 0 0 1 11 0z" />
    <path d="M1.5 18.5a3.9 3.9 0 0 1 5.6-3.5 7 7 0 0 0-1.8 3.5zM22.5 18.5a3.9 3.9 0 0 0-5.6-3.5 7 7 0 0 1 1.8 3.5z" />
  </svg>
);

const RoleIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
    <path d="M14 3v5h5" />
    <path d="M9 12.5h6M9 16h6" />
  </svg>
);

const DLAs = () => {
  const partnerDetails = [
    { icon: <BankIcon />, label: 'Lending Partner', value: 'Ampire Finance Private Limited' },
    { icon: <PlatformIcon />, label: 'Platform', value: 'LoanWalle' },
    { icon: <OperatorIcon />, label: 'Operator', value: 'Ampire Fintech Private Limited' },
    { icon: <RoleIcon />, label: 'Role', value: 'Loan Service Provider (LSP) and marketing/distribution partner' },
  ];

  return (
    <div className="dlas-page">
      {/* Hero Banner */}
      <section className="dla-hero" style={{ backgroundImage: `url(${dlaBanner})` }}>
        <div className="dla-hero-overlay">
          <div className="dla-container">
            <span className="dla-hero-eyebrow">DLAs</span>
            <h1 className="dla-hero-title">Digital Lending<br />Partners</h1>
            <div className="dla-hero-line"></div>
            <p className="dla-hero-subtitle">
              Building responsible and accessible digital lending solutions through trusted partnerships.
            </p>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="dla-partners">
        <div className="dla-container">
          <h2 className="dla-section-title">Our Digital Lending Partners</h2>
          <div className="dla-section-line"></div>
          <p className="dla-section-description">
            We collaborate with trusted digital lending platforms to expand access to credit for individuals and businesses.
          </p>

          <div className="dla-partner-card">
            <div className="dla-partner-logo">
              <img src="/loanwallelogo.webp" alt="LoanWalle - The Future of Smart Finance" />
            </div>

            <div className="dla-partner-about">
              <h3 className="dla-partner-name">LoanWalle</h3>
              <p>
                LoanWalle is a digital lending and customer acquisition platform operated by{' '}
                <strong>Ampire Fintech Private Limited</strong>, an authorized Loan Service Provider (LSP) and
                marketing/distribution partner of <strong>Ampire Finance Private Limited</strong>.
              </p>
              <p>
                Through LoanWalle, customers can discover and apply for eligible financial products offered by
                Ampire Finance, subject to applicable eligibility criteria, credit assessment and lending terms.
              </p>
            </div>

            <div className="dla-partner-details">
              {partnerDetails.map((detail) => (
                <div className="dla-detail-row" key={detail.label}>
                  <div className="dla-detail-icon">{detail.icon}</div>
                  <div className="dla-detail-label">{detail.label}</div>
                  <div className="dla-detail-value">{detail.value}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="dla-notice">
            <span className="dla-notice-icon">i</span>
            <p>
              Ampire Finance Private Limited is the lender and is responsible for loan sanction and disbursement.
              LoanWalle does not itself sanction or disburse loans.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DLAs;
